
export enum TrackingEvent {

    SUBSCRIPTION_MODAL_OPEN = 'billing.subscription.modal_open',
    
}